module.exports = __webpack_public_path__ + "img/2.b98679c5.png";